import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import { TransformType } from 'new/components/ReusableTransform/types';
import React, { Component } from 'react';
import Menu from '../../../components/elements/menu/Menu';

import { ReactComponent as EditFileIcon } from 'new/components/icons/editFile.svg';
import { ReactComponent as DeleteIcon } from 'new/components/icons/fi-rr-trash.svg';
import { ReactComponent as DetailsIcon } from 'new/components/icons/fi-rr-info.svg';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import {
  ROUTE_MY_DATA_SETS,
  ROUTE_REDESIGN,
  ROUTE_REUSABLE_TRANSFORMS,
} from 'js/constants/pathnames';
import { withRouter } from 'react-router-dom';

class ReusableTxDetailActions extends Component {
  render() {
    const { readOnly, isManaged, disableEditing, disableEditMessage, data, hideMenuDetails } =
      this.props;
    const isInUse = has(data, 'data_sets') && !isEmpty(data.data_sets);

    let menuItems = [];
    if (!hideMenuDetails) {
      menuItems.push({
        label: 'Details',
        icon: <DetailsIcon />,
        onClick: this._handleOpenDetails,
      });
    }
    let editMenuItem = {
      label: 'Edit',
      icon: <EditFileIcon />,
      onClick: this._handleEditClicked,
    };

    if (!isNil(disableEditing) && disableEditMessage && disableEditing) {
      editMenuItem.disable = true;
      editMenuItem.disableMessage = disableEditMessage;
    } else if (isManaged === true) {
      editMenuItem.disable = true;
      editMenuItem.disableMessage =
        'This transform is managed by Nexla. Please contact support@nexla.com for editing this transform.';
    }
    menuItems.push(editMenuItem);

    let deleteMenuItem = {
      type: 'dialog',
      label: 'Delete',
      icon: <DeleteIcon />,
      dialogMessage: `Please confirm you want to delete transform ${data.name}(ID: ${data.id})`,
      primaryButtonColor: 'error',
      discardLabel: 'Cancel',
      confirmLabel: 'Delete',
      onClick: this._handleDeleteClicked,
    };

    if (isInUse) {
      deleteMenuItem.disable = true;
      deleteMenuItem.disableMessage =
        'This transform cannot be deleted as it is being used in a Nexset';
    }

    menuItems.push(deleteMenuItem);

    if (this.props.additionalMenuItems) {
      this.props.additionalMenuItems.forEach((item) => {
        if (item.position === 'bottom') {
          menuItems.push(item);
        } else {
          menuItems.unshift(item);
        }
      });
    }

    return (
      <div className="detail-actions">
        {!readOnly && <Menu horizontalDots={this.props.horizontalDots} items={menuItems} />}
      </div>
    );
  }

  _handleEditClicked = () => {
    if (!this.props.data.reusable && this.props.dataSet) {
      this.props.history.push(
        `${ROUTE_CONNECT}${ROUTE_MY_DATA_SETS}/${this.props.dataSet.id}/edit`,
      );
      return;
    }
    if (this.props.onEditButtonClicked) {
      this.props.onEditButtonClicked?.(this.props.data);
      return;
    }
    this.props.history.push(
      `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_REUSABLE_TRANSFORMS}?editId=${this.props.data.id}&editType=${this.props.data.output_type}`,
    );
  };

  _handleDeleteClicked = () => {
    if (this.props.data.output_type === TransformType.ATTRIBUTE) {
      this.props.deleteAttributeTransform(this.props.data.id);
    } else if (this.props.data.output_type === TransformType.RECORD) {
      this.props.deleteRecordTransform(this.props.data.id);
    } else if (this.props.data.output_type === TransformType.CUSTOM) {
      this.props.deleteCodeContainer(this.props.data.id);
    }
  };

  _handleOpenDetails = (e) => {
    if (e && typeof e.stopPropagation === 'function') {
      e.stopPropagation();
    }
    const { data, onOpenDetailsMenu, openDetailDrawerInPortal, openDetailsModal } = this.props;
    if (typeof onOpenDetailsMenu === 'function') {
      onOpenDetailsMenu(data);
      return;
    }
    if (typeof openDetailsModal === 'function') {
      openDetailsModal(data);
      return;
    }
    if (typeof openDetailDrawerInPortal === 'function') {
      openDetailDrawerInPortal(data, {});
    }
  };
}

ReusableTxDetailActions.defaultProps = {
  hideMenuDetails: false,
};

export default withRouter(ReusableTxDetailActions);
